import React from 'react';
import MaterialTableCell from '@mui/material/TableCell';
import type {TableCellProps as MaterialTableCellProps} from '@mui/material/TableCell';
import {styled} from '@mui/material/styles';

type BaseTableCellProps = Omit<MaterialTableCellProps, 'padding' | 'variant'>;

export type TableCellProps = BaseTableCellProps;

const StyledTableCell = styled(MaterialTableCell)(() => ({
    borderBottom: 'none',
    '&.MuiTable-stickyHeader td': {
        borderBottom: 'none'
    }
}));

export const TableCell = React.forwardRef<any, TableCellProps>(({
    children, ...props
}, ref) => (
    <StyledTableCell
        ref={ref}
        {...props}
    >
        {children}
    </StyledTableCell>
));

TableCell.displayName = 'TableCell';
